import { Pagination } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function NoRecipesTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.noRecipesTasksSelector);
  const status = useSelector(taskRedux.noRecipesTasksStatusSelector);
  const page = useSelector(taskRedux.noRecipesTasksPageSelector);
  const count = useSelector(taskRedux.noRecipesTasksCountSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveNoRecipesTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveNoRecipesTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          onRefresh={() => dispatch(taskRedux.actions.retrieveNoRecipesTasks())}
          loading={status === 'loading'}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default NoRecipesTable;
